import { kebabCase } from 'lodash-es';
import type { HBDropdownOption } from './HBDropdown.types';

export const addTestIdToInnerProps = (
    props: Record<string, any>,
    testId: string,
    componentName: string
) => {
    if (!testId || !componentName) {
        return props;
    }
    // <Input/> doesn't have innerProps
    const target = props.innerProps || props;
    const testIdProp = {
        'data-testid': `${testId}-${kebabCase(componentName)}`
    };
    Object.assign(target, testIdProp);

    return props;
};

/**
 * Changes whenever the selected options or the size change, which is what
 * makes the fit measurement stale. A label is part of the key only when it is
 * a string: a JSX label can be circular (React's `_owner`), which makes
 * JSON.stringify throw. JSON keeps values and labels that contain separator
 * characters from colliding.
 */
export const getSelectionFitKey = (
    size: string,
    selected: HBDropdownOption[]
) =>
    JSON.stringify([
        size,
        selected.map(option =>
            typeof option.label === 'string'
                ? [option.value, option.label]
                : [option.value]
        )
    ]);
